import React from 'react';
import { Typography } from 'fronton-react';
import { costStyles } from './styles';
import { Gallery } from './components/gallery';

export const Cost = () => (
	<div className={costStyles}>
		<div className="cost-text">
			<Typography className="title" variant="h2">
				Перечень и стоимость работ
			</Typography>
			<Typography variant="m" size="body_long">
				Мы выполняем все виды черновых работ — от демонтажа до стяжки пола и гидроизоляции.
				Можете заказать услуги как по отдельности, так и комплексно
			</Typography>
		</div>
		<Gallery />
	</div>
);
